export default function ErrorPage() {
  return (<h2>잘못된 요청입니다</h2>);
}
